import Auth from '@aws-amplify/auth';
import {
  PasswordInput,
  passwordValidation,
} from 'Components/Auth/PasswordInput';
import Button from 'Components/Buttons/Button';
import Form from 'Components/Form';
import { errorToast, successToast } from 'Components/Notifications';
import { useState } from 'react';
import { SubmitHandler } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';

export interface IChangePasswordProps {}
export default function ChangePassword(props: IChangePasswordProps) {
  let initialData: FormInputs = {
    currentPassword: '',
    newPassword: '',
    repeatPassword: '',
  };
  type FormInputs = {
    currentPassword: string;
    newPassword: string;
    repeatPassword: string;
  };
  const validationSchema = Yup.object().shape({
    currentPassword: Yup.string().required('required'),
    newPassword: passwordValidation,
    repeatPassword: Yup.string().oneOf(
      [Yup.ref('newPassword'), null],
      'Passwords must match',
    ),
  });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit: SubmitHandler<FormInputs> = async (data) => {
    setIsLoading(true);
    Auth.currentAuthenticatedUser().then((user) => {
      return Auth.changePassword(user, data.currentPassword, data.newPassword)
        .then((data) => {
          navigate(`/dashboard/profile`);
          successToast('Your password has been updated');
        })
        .catch((e) => {
          setIsLoading(false);
          errorToast(e.message);
        });
    });
  };

  return (
    <div className="p-4">
      <div>
        <p className="font-bold  text-medium">Change Password</p>
      </div>
      <div className="mt-6">
        <p className=" text-sm text-gray-700 ">
          Please enter your Current password to reset it.
        </p>
        <div className="mb-6">
          <Form
            onSubmit={onSubmit}
            defaultValues={initialData}
            validationSchema={validationSchema}
          >
            {() => (
              <>
                <div className="flex w-full ">
                  <div className="w-1/3 md-max:w-full">
                    <PasswordInput
                      name="currentPassword"
                      rules={{ required: 'required' }}
                      placeholder="Current Password"
                    />
                  </div>
                </div>
                <div className="mt-9 ">
                  <p className=" text-sm text-gray-700 ">
                    Create your new password.{' '}
                  </p>
                </div>

                <div className="flex w-full ">
                  <div className="w-1/3 md-max:w-full">
                    <PasswordInput
                      name="newPassword"
                      rules={{ required: 'required' }}
                      placeholder="New Password"
                    />
                  </div>
                </div>
                <div className="flex w-full mb-3">
                  <div className="w-1/3 md-max:w-full">
                    <PasswordInput
                      name="repeatPassword"
                      rules={{ required: 'required' }}
                      placeholder="Repeat Password"
                    />
                  </div>
                </div>

                <div className="w-1/3 flex flex-inline gap-4 mt-9 md-max:w-full md-max:grid">
                  <Button
                    disabled={isLoading}
                    isLoading={isLoading}
                    theme="green-fill"
                    type="submit"
                  >
                    Save
                  </Button>
                  <Button
                    disabled={isLoading}
                    type="button"
                    onClick={() => navigate(`/dashboard/profile`)}
                  >
                    Cancel
                  </Button>
                </div>
              </>
            )}
          </Form>
        </div>
      </div>
    </div>
  );
}
